// @ts-ignore
export const apiUrl = ENVJS_API_URL ?? "http://localhost:8080";
// @ts-ignore
export const appUrl = ENVJS_APP_URL ?? "http://localhost:5173";
// @ts-ignore
export const version = ENVJS_APP_VERSION ?? "dev";
// @ts-ignore
export const stage = ENVJS_APP_STAGE ?? "development";

export const oidcClientId =
  import.meta.env.VITE_OIDC_CLIENT_ID ?? "volzalyzer-app";

export const contentWidth = "lg";
